// @ts-ignore
import delay from 'lodash/delay';
import {ShowHide} from './ShowHideClass';

export class Tabs {
  container: HTMLElement;
  items: NodeListOf<HTMLElement>
  triggers: NodeListOf<HTMLElement>
  showHides: ShowHide[];

  constructor(container) {
    this.container = container;
    this.triggers = this.container.querySelectorAll('[data-tabs-trigger]');
    this.items = this.container.querySelectorAll('[data-tabs-item]');
    this.showHides = []
    this.init();
    this.addTriggerEvents();
  }

  init() {
    this.items.forEach((item, index) => {
      let trigger: HTMLElement = this.container.querySelector('[data-tabs-trigger="' + item.dataset.tabsItem + '"]')
      let showHide: ShowHide = new ShowHide(
        trigger,
        item,
        false,
        true,
        false
      );
      this.showHides.push(showHide);
    });
    delay(() => {
      this.showHides[0].show();
    }, 500);
  }

  addTriggerEvents() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const target = event.currentTarget as HTMLTextAreaElement

        if (!target.classList.contains('is-active')) {
          this.showHides.forEach((showHide) => {
            if (showHide.trigger === trigger && showHide.isActive === false) {
              showHide.show();
            } else {
              showHide.hide();
            }
          });
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLElement>('[data-tabs-container]').forEach(tabsContainer => {
    new Tabs(tabsContainer);
  });
});
